module.exports = __webpack_public_path__ + "img/sh.61896a47.svg";